<template>
    <div class="d-flex justify-content-between align-items-center">
        <NuxtLinkLocale to="index" class="d-none d-lg-block navbar-brand"/>

        <div class="col-12 col-lg-auto order-1 order-lg-2 top-nav d-flex align-items-center justify-content-end flex-grow-1 position-relative">
            <ul class="navbar-nav flex-row align-items-center justify-content-between justify-content-lg-end w-100">
                <li class="nav-item d-block d-lg-none d-flex align-items-center">
                    <a href="#" class="nav-link nav-menu has-dark navbar-toggler ms-0 me-3" @click.prevent="emit('toggle-menu')">{{ $t('Menu') }}</a>
                    <ProfileMenu/>
                </li>

                <li class="nav-item d-none d-lg-block flex-grow-1 desktop-search-container">
                    <div class="position-relative w-100">
                        <div ref="searchRef" :class="['search-overlay-desktop', { 'd-none': !showSearch }]">
                            <ProductSearch
                                ref="searchComponent"
                                query-name="term"
                                :always-show-close="true"
                                :empty-on-close="true"
                                @close="showSearch = false"
                            />
                        </div>
                    </div>
                </li>

                <li class="nav-item d-none d-md-block d-md-none">
                    <NuxtLink class="nav-link nav-charts" :to="localePath({ name: 'charts-code', params: { code: $t('url.gold-price') } })">
                        {{ $t('Charts') }}
                    </NuxtLink>
                </li>

                <!-- Mobile centered logo -->
                <li class="d-block d-lg-none mobile-logo-centered" v-if="!showSearch">
                    <NuxtLinkLocale class="navbar-brand me-0" :title="settingsStore.get('setting.site_name')" to="index"/>
                </li>

                <li class="nav-item d-none d-lg-block">
                    <button v-if="!showSearch" class="nav-link nav-item-icon has-dark nav-search" @click.stop="showSearch = true"/>
                </li>

                <li class="nav-item d-none d-lg-block"><Watchlist/></li>
                <li class="nav-item d-none d-lg-block"><ProfileMenu/></li>

                <li class="nav-item d-flex align-items-center text-end">
                    <button class="nav-link nav-item-icon nav-search has-dark d-block d-lg-none me-3" @click.stop="showSearch = true"/>
                    <Cart/>
                </li>
            </ul>
            <div ref="searchRef" class="w-100 d-block d-lg-none mobile-search-overlay" v-if="showSearch && !isDesktop">
                <ProductSearch
                    ref="searchComponent"
                    query-name="term"
                    :always-show-close="true"
                    :empty-on-close="true"
                    @close="showSearch = false"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const Watchlist = defineAsyncComponent(() => import('~/components/Watchlist.vue'))
const ProfileMenu = defineAsyncComponent(() => import('~/components/ProfileMenu.vue'))
import { useSettingsStore } from '~/stores/SettingsStore'
import { useLocalePath } from '#imports'

const isDesktop = ref(false)

const updateIsDesktop = () => {
    if (typeof window !== 'undefined') {
        isDesktop.value = window.innerWidth >= 992
    }
}

const emit = defineEmits(['toggle-menu']);

const settingsStore = useSettingsStore()
const localePath = useLocalePath()

const showSearch = ref(false)
const searchRef = ref(null)

watch(showSearch, async v => {
    if (v) {
        await nextTick()
        searchRef.value?.querySelector('input')?.focus()
    }
})

function handleClickOutside(e) {
    if (showSearch.value && searchRef.value && !searchRef.value.contains(e.target)) {
        showSearch.value = false
    }
}

onMounted(() => {
    updateIsDesktop()
    window.addEventListener('resize', updateIsDesktop)
    document.addEventListener('click', handleClickOutside)
});

onUnmounted(() => {
    window.removeEventListener('resize', updateIsDesktop)
    document.removeEventListener('click', handleClickOutside)
})

</script>
